import { FC, useEffect, useState } from "react";
import axios from "axios";
import { URL } from '../../../redux/common/url';
import { toast } from "react-toastify";
import { handleCopy, handleCSV, handleCSVNew, handleExcel, handlePDF, handlePDFNew, handleExcelNew } from '../Provisional/print';
import moment from 'moment';
import { Link } from "react-router-dom";
import clsx from "clsx";
import { AsyncPaginate } from "react-select-async-paginate";
import { reportColumns } from "../../constant";
import ReactPaginate from "react-paginate";


interface Value {
  id: string
  name: string
}

interface Option {
  id: string
}

interface Options {
  value: string
  label: string
};

interface PaginatedResponse {
  results: Options[]
  has_more: boolean
};

const Vef_Disapproval: FC = () => {

  const [circle_id, setCircle_id] = useState('');
  const [vendor_id, setVendor_id] = useState('');
  const [fromdate, setfromdate] = useState('');
  const [todate, settodate] = useState('');
  const [vehical_id, setVehical_id] = useState('');
  const [circles, setCircles] = useState<Value[]>([]);
  const [name, setName] = useState<string>('');
  const [reportData, setReportData] = useState<any[]>([]);
  const [approved, setApproved] = useState<Option[]>([]);
  const [pageNo, setpageNo] = useState<any>(1);
  const [pageCount, setPageCount] = useState(0);

  // XEN / AEN / JEN
  const [seleceteMangerXenForFilters, setseleceteMangerXenForFilters] = useState<any>({})
  const [seleceteMangerAenForFilters, setseleceteMangerAenForFilters] = useState<any>({})
  const [seleceteMangerJenForFilters, setseleceteMangerJenForFilters] = useState<any>({})

  const [managerKey, setManagerKey] = useState(0)
  const [managerKeyAen, setManagerKeyAen] = useState(0)
  const [managerKeyJen, setManagerKeyJen] = useState(0)


  const totalAmount = reportData?.reduce((acc, curr) => acc + curr.amount, 0)

  useEffect(() => {
    fetchCircles();
    getReports();
  }, [pageNo]);

  const handlePageClick = (event: any) => {
    const data = event?.selected + 1
    setpageNo(data)
  };

  const getReports = async () => {
    try {
      const token: any = await localStorage.getItem('kt-auth-react-v')
      const config = {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token).api_token,
        },
      }
      var cms = ''
      if (circle_id) {
        cms = `&circle_id=${circle_id}`
      }
      if (seleceteMangerXenForFilters?.id) {
        cms += `&xen_id=${seleceteMangerXenForFilters.id}`
      }
      if (seleceteMangerAenForFilters?.id) {
        cms += `&aen_id=${seleceteMangerAenForFilters.id}`
      }
      if (seleceteMangerJenForFilters?.id) {
        cms += `&jen_id=${seleceteMangerJenForFilters.id}`
      }

      if (pageNo) {
        cms = cms + `&page=${pageNo}`
      }
      if (vendor_id) {
        cms = cms + `&vendor=${vendor_id}`
      }
      if (vehical_id) {
        cms = cms + `&vehicle=${vehical_id}`
      }

      if (fromdate) {
        cms = cms + `&fromdate=${fromdate}`
      }
      if (todate) {
        cms = cms + `&todate=${todate}`
      }
      if (name) {
        cms = cms + `&search=${name}`
      }
      const res = await axios.get(
        `${URL.API_BASE_URL}${URL.getReports}?approved=reject${cms}`,
        config
      )
      if (res?.data?.data?.data) {
        setReportData(res?.data?.data?.data)
        setPageCount(Math.ceil(res?.data?.data?.total / 50))
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  };

  const all_vehicles = async (e: any) => {
    setVendor_id(e);
    setVehical_id('')
  };

  const fetchCircles = async () => {
    try {
      const response: any = await axios.get(`${URL.API_BASE_URL + URL.getAllCircles}`)
      if (response?.data?.data) {
        setCircles(response?.data?.data)
      }
    } catch (error) {
      console.log(error)
    }
  };

  const fetchgetAllVendor = async (e: any) => {
    try {
      // Circle
      setCircle_id(e)

      // 🔹 RESET CHAIN BELOW CIRCLE
      setseleceteMangerXenForFilters({})
      setseleceteMangerAenForFilters({})
      setseleceteMangerJenForFilters({})

      setVendor_id('')
      setVehical_id('')

      // 🔹 FORCE REMOUNT OF ASYNC DROPDOWNS
      setManagerKey(k => k + 1)
      setManagerKeyAen(k => k + 1)
      setManagerKeyJen(k => k + 1)

      // (optional – API call not actually needed for UI reset)
      await axios.get(
        `${URL.API_BASE_URL}${URL.getVendorList}?circle_id=${e}`
      )

    } catch (error) {
      console.log(error)
    }
  };


  // New function to handle pending status for selected rows
  const pendingBulkReport = async () => {
    try {
      if (approved.length === 0) {
        toast.error('Please select at least one record')
        return
      }
      const token: any = await localStorage.getItem('kt-auth-react-v')
      const config = {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token).api_token,
        },
      }
      const res = await axios.post(
        `${URL.API_BASE_URL}/api/admins/approveBulkReport`,
        { ids: approved, approved: 'pending' }, // Status set to 'pending'
        config
      )
      if (res?.data?.data) {
        getReports() // Refresh the report data
        toast.success(res?.data?.message)
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  };

  const loadOptionsgetManagerXenForFilters = async (search: any, loaded: any, { page }: any) => {
    if (!circle_id) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const res = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${circle_id}`,
      { headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` } }
    )

    const json = await res.json()

    return {
      options: json?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: json.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerAenForFilters = async (search: any, loaded: any, { page }: any) => {
    if (!seleceteMangerXenForFilters?.id) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const res = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerXenForFilters.id}&circle_id=${circle_id}`,
      { headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` } }
    )

    const json = await res.json()

    return {
      options: json?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: json.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerJenForFilters = async (search: any, loaded: any, { page }: any) => {
    if (!seleceteMangerAenForFilters?.id) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const res = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerAenForFilters.id}&circle_id=${circle_id}`,
      { headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` } }
    )

    const json = await res.json()

    return {
      options: json?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: json.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsVendor = async (search: any, loadedOptions: any, { page }: { page: any, }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');

    let url = `${URL.getVendorList}?circle_id=${circle_id}`;
    if (seleceteMangerJenForFilters?.id) {
      url += `&jen_id=${seleceteMangerJenForFilters.id}`
    }

    const response = await fetch(`${URL.API_BASE_URL + url}&page=${page}&search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );
    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.id;
      data.label = data?.name;
      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    }
  };

  const loadOptionsVehicle = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');

    let url = `${URL.all_vendors_tanker}?vendor_id=${vendor_id}`;

    const response = await fetch(`${URL.API_BASE_URL + url}&page=${page}&search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );
    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.vehicle_id;
      data.label = data?.vehicle?.registration_number;
      return data;
    });
    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    }
  };

  const handleDownload = async () => {
    try {
      const token: any = await localStorage.getItem('kt-auth-react-v')
      const config = {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token).api_token,
        },
      }

      var cms = ''
      if (circle_id) {
        cms = `&circle_id=${circle_id}`
      }
      if (seleceteMangerXenForFilters?.id) {
        cms += `&xen_id=${seleceteMangerXenForFilters.id}`
      }
      if (seleceteMangerAenForFilters?.id) {
        cms += `&aen_id=${seleceteMangerAenForFilters.id}`
      }
      if (seleceteMangerJenForFilters?.id) {
        cms += `&jen_id=${seleceteMangerJenForFilters.id}`
      }

      if (vendor_id) {
        cms = cms + `&vendor=${vendor_id}`
      }
      if (vehical_id) {
        cms = cms + `&vehicle=${vehical_id}`
      }

      if (fromdate) {
        cms = cms + `&fromdate=${fromdate}`
      }
      if (todate) {
        cms = cms + `&todate=${todate}`
      }
      if (name) {
        cms = cms + `&search=${name}`
      }
      const res = await axios.get(
        `${URL.API_BASE_URL}${URL.downloadReports}?approved=reject${cms}`,
        config
      );
      if (res?.data?.data) {
        return res?.data?.data;
      };
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    };
  };

  return (
    <div>
      <div className='d-flex justify-content-between'>
        <h3 className='text-gray-600'>Disapproval Report</h3>
        <p>
          <span className='text-primary'>Home</span> / Disapproval Report
        </p>
      </div>
      <div className={clsx('shadow m-0 p-4 rounded-2x')}>
        {/* Filter Options */}
        <div className="row g-3 align-items-end">

          {/* Circle */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Circle</label>
            <select
              className="form-control"
              aria-label="Select Circle"
              name="circle_id"
              onChange={(e: any) => {
                fetchgetAllVendor(e.target.value)
              }}
            >
              <option value="">Select Circle</option>
              {circles?.map((data, i) => (
                <option value={data?.id} key={i}>
                  {data?.name}
                </option>
              ))}
            </select>
          </div>

          {/* XEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select XEN</label>
            <AsyncPaginate
              key={managerKey}
              value={seleceteMangerXenForFilters}
              loadOptions={loadOptionsgetManagerXenForFilters}
              onChange={(e: any) => {
                setseleceteMangerXenForFilters(e)
                setseleceteMangerAenForFilters({})
                setseleceteMangerJenForFilters({})
                setManagerKeyAen(k => k + 1)
                setManagerKeyJen(k => k + 1)
                setVendor_id('')
                setVehical_id('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* AEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select AEN</label>
            <AsyncPaginate
              key={managerKeyAen}
              value={seleceteMangerAenForFilters}
              loadOptions={loadOptionsgetManagerAenForFilters}
              onChange={(e: any) => {
                setseleceteMangerAenForFilters(e)
                setseleceteMangerJenForFilters({})
                setManagerKeyJen(k => k + 1)
                setVendor_id('')
                setVehical_id('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* JEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select JEN</label>
            <AsyncPaginate
              key={managerKeyJen}
              value={seleceteMangerJenForFilters}
              loadOptions={loadOptionsgetManagerJenForFilters}
              onChange={(e: any) => {
                setseleceteMangerJenForFilters(e)
                setVendor_id('')
                setVehical_id('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Vendor */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Vendor</label>
            <AsyncPaginate<any, any, any>
              key={`${circle_id}-${seleceteMangerJenForFilters?.id || 'no-jen'}`}
              loadOptions={loadOptionsVendor}
              onChange={(item: any) => all_vehicles(item?.value)}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Vehicle */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Vehicle</label>
            <AsyncPaginate<any, any, any>
              key={vendor_id}
              loadOptions={loadOptionsVehicle}
              onChange={(e: any) => setVehical_id(e?.vehicle_id)}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Date From */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Date From</label>
            <input
              className="form-control"
              type="date"
              onChange={(e: any) => setfromdate(e.target.value)}
            />
          </div>

          {/* Date To */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Date To</label>
            <input
              className="form-control"
              type="date"
              onChange={(e: any) => settodate(e.target.value)}
            />
          </div>

          {/* View Button */}
          <div className="col-md-2">
            <button
              className="btn w-100"
              style={{ backgroundColor: '#52A841', color: '#fff' }}
              onClick={() => {
                getReports()
              }}
            >
              View
            </button>
          </div>
        </div>

        <div className='d-flex justify-content-betq align-items-center gap-4 px-5'>
          <div className='d-flex gap-1'>
            <div
              className='p-2'
              style={{ border: '1px solid #000', backgroundColor: '#ADAFAD' }}
              onClick={async () => {
                const data = await handleDownload();
                handleCSVNew(data, reportColumns, "Disapproval Report", fromdate, todate)
              }}
            >
              CSV
            </div>
            <div
              className='p-2'
              style={{ border: '1px solid #000', backgroundColor: '#ADAFAD' }}
              onClick={async () => {
                const data = await handleDownload();
                handlePDFNew(data, reportColumns, " Disapproval Report", fromdate, todate)
              }}
            >
              PDF
            </div>
            <div
              className='p-2'
              style={{ border: '1px solid #000', backgroundColor: '#ADAFAD' }}
              onClick={async () => {
                const data = await handleDownload();
                handleExcelNew(data, reportColumns, "Disapproval Report", fromdate, todate)
              }}
            >
              EXCEL
            </div>
          </div>

          <div>
            <input
              type='search'
              placeholder='Search wise mobile number'
              className='form-control'
              onChange={(e: any) => setName(e.target.value)}
            />
          </div>
          <div
            onClick={pendingBulkReport}
            style={{
              backgroundColor: '#ADAFAD',
              color: 'white',
              height: '30px',
              width: '250px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            Pending Selected
          </div>
        </div>

        {/* Vehicle table  */}
        <div className='mt-9'>
          <table className='table' style={{ fontSize: '10px', fontWeight: '300' }}>
            <thead className='table-light'>
              <tr>
                <th>S.NO.</th>
                <th>Job Id</th>
                <th>Pickup location</th>
                <th>Drop location</th>
                <th>Pickup Date / time</th>
                <th>End Date / time</th>
                <th>Trip Duration</th>
                <th>Name</th>
                <th>Number</th>
                <th>Tanker Number</th>
                <th>Distance</th>
                <th>Amount</th>
                <th>Remarks</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ maxHeight: '60vh', overflow: 'auto' }}>
              {reportData.length > 0 &&
                reportData.map((item: any, index: any) => (

                  <tr
                    key={index}
                    onClick={() => {
                      approved.includes(item?.id)
                        ? setApproved((prev) =>
                          prev.filter((approvedId) => approvedId !== item?.id)
                        )
                        : setApproved((prev) => [...prev, item?.id])
                    }}
                    className={approved.includes(item?.id) ? 'bg-success text-white' : ''}
                    style={{ backgroundColor: '#E54236', color: 'white' }}
                  >
                    <td> {(pageNo - 1) * 50 + index + 1} </td>
                    <td>{item?.id}</td>
                    <td>{item?.source_hydrant_center?.address}</td>
                    <td>{item?.destination?.address}</td>
                    <td>{item?.accepted_time}</td>
                    <td>{item?.complete_time}</td>
                    <td>{item?.trip_duration}</td>
                    <td>{item?.user?.name}</td>
                    <td>{item?.user?.mobile}</td>
                    <td>{item?.vehicle?.registration_number}</td>
                    <td>{item?.total_distance}</td>
                    <td>{item?.amount}</td>
                    <td>{item?.remark}</td>
                    <td>
                      <Link to={`/view_details/${item?.id}/reject`}>
                        <button className='btn-group btn-group-sm bg-primary text-white'>
                          View Details
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>

            <tfoot>
              <tr>
                <td colSpan={6}></td>
                <td>
                  <b>Date</b>
                </td>
                <td>
                  {' '}
                  {fromdate ? fromdate : '--'} to{todate ? todate : '--'}
                </td>
                <td colSpan={2}></td>
                <td>
                  <b>Total</b>
                </td>
                <td colSpan={2} className='text-center fs-5'>
                  {totalAmount}
                </td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={14} style={{ textAlign: 'center' }}>
                  This is System Generated Report it does not require any signature or stamp.
                </td>
              </tr>
            </tfoot>
          </table>
          {/* <p>Showing 1 to 201 of 201 entries</p>  */}
          <div style={{ height: '45px' }}>
            <ReactPaginate
              breakLabel='...'
              nextLabel='next'
              className='dataTables_paginate paging_simple_numbers category'
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              pageCount={pageCount}
              previousLabel='previous'
            // renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Vef_Disapproval
